"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.replace");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _project = require("@/api/project/project");
var _courseDeclare = require("@/api/courseDeclare/courseDeclare");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      majorDialog: false,
      maxDialog: false,
      maxAuditDialog: false,
      addDialog: false,
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "项目单位名称"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "项目单位名称",
        prop: "name",
        isShow: true,
        width: "200"
      },
      // {
      //   name: "编码",
      //   prop: "bureauCode",
      //   isShow: true,
      //   width: "100"
      // },
      // {
      //   name: "最大作品数",
      //   prop: "maxWorks",
      //   isShow: true,
      //   width: "100"
      // },
      // {
      //   name: "最大审核数",
      //   prop: "auditNumber",
      //   isShow: true,
      //   width: "100"
      // },
      {
        name: "创建时间",
        prop: "createTime",
        isShow: true,
        width: "200"
      }
      // {
      //   name: "更新时间",
      //   prop: "updateTime",
      //   isShow: true,
      //   width: "200",
      // }
      ],
      funBtns: [
      //   {
      //   size: "small",
      //   click: "setMaxWorksBtn",
      //   icon: "el-icon-delete",
      //   name: "设置最大作品数",
      //   type: "primary"
      // },
      {
        size: "small",
        click: "removeUnit",
        icon: "el-icon-delete",
        name: "移出",
        type: "danger"
      }, {
        size: "small",
        click: "save",
        icon: "el-icon-circle-plus-outline",
        name: "新增",
        type: "primary"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      options: [
      // {
      //   name: "设置最大作品数",
      //   class: "edit",
      //   option: "modify",
      //   span: 14
      // }, 
      {
        name: "设置最大审核数",
        class: "edit",
        isFuntion: true,
        optionFun: "checkAudit",
        option: "audit",
        span: 14
      },
      // {
      //   name: "下载申报材料",
      //   class: "delet",
      //   option: "downloadById",
      //   span: 10
      // },
      {
        name: "移出",
        class: "delet",
        option: "removeUnit",
        span: 10
      }],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      matchId: "",
      queryValue: "",
      treeList: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      maxForm: {
        max: ""
      },
      maxAuditForm: {
        max1: 0,
        max2: 0,
        id: ''
      },
      nodeList: [],
      checkBoxs: [],
      materialList: [],
      schoolId: []
    };
  },
  methods: {
    isnumber: function isnumber(val) {
      val = val.replace(/[^0-9]/gi, "");
      // 此处还可以限制位数以及大小
      return val;
    },
    listAuditNumber: function listAuditNumber() {
      var _this = this;
      (0, _courseDeclare.getListAuditNumber)({
        matchId: this.matchId,
        schoolId: this.schoolId
      }).then(function (res) {
        // console.log('resdddd',res)
        if (res.data) {
          _this.maxAuditForm.id = res.data.id;
          _this.maxAuditForm.max2 = res.data.cognizanceNumber;
          _this.maxAuditForm.max1 = res.data.number;
        }
      });
    },
    saveAudit: function saveAudit() {
      var _this2 = this;
      (0, _courseDeclare.saveAuditNumber)({
        cognizanceNumber: this.maxAuditForm.max2,
        id: this.maxAuditForm.id,
        number: this.maxAuditForm.max1,
        matchId: this.matchId,
        schoolId: this.schoolId
      }).then(function (res) {
        if (res.code == 2000) {
          _this2.$message.success(res.msg);
          _this2.maxAuditDialog = false;
          _this2.maxAuditForm.max2 = '';
          _this2.maxAuditForm.max1 = '';
          _this2.maxAuditForm.id = '';
        }
      });
    },
    // 设置最大作品数按钮
    setMaxWorksBtn: function setMaxWorksBtn() {
      this.maxDialog = true;
    },
    //下载申报材料
    downloadById: function downloadById(row) {
      var _this3 = this;
      (0, _project.getMatchMaterialUrl)({
        matchId: this.matchId,
        schoolId: row.schoolId
      }).then(function (res) {
        if (res.code == 2000) {
          _this3.majorDialog = true;
          _this3.materialList = res.data;
        } else {
          _this3.$message.error("暂无材料");
          return false;
        }
      });
    },
    audit: function audit(row) {
      console.log('ttt', row);
      this.schoolId = row.schoolId;
      this.listAuditNumber();
      this.maxAuditDialog = true;
      this.checkBoxs = [];
      this.checkBoxs.push(row.id);
    },
    checkAudit: function checkAudit(row, collback) {
      if (row.schoolType == 2) {
        return collback(true);
      } else {
        return collback(false);
      }
    },
    modify: function modify(row) {
      console.log('ss', row);
      this.maxDialog = true;
      this.checkBoxs = [];
      this.checkBoxs.push(row.id);
    },
    // audit(row) {
    //   this.maxAuditDialog = true;
    //   this.checkBoxs = [];
    //   this.checkBoxs.push(row.id)
    // },
    //下载
    download: function download(url, name) {
      console.log(url);
      if (url == null || url == "") {
        this.$message.error("暂无材料");
        return false;
      } else {
        var a = document.createElement('a');
        fetch(url).then(function (res) {
          return res.blob();
        }).then(function (blob) {
          a.href = URL.createObjectURL(blob);
          console.log(a.href);
          var start = url.lastIndexOf(".");
          var s = url.substring(start, url.length);
          a.download = name + s; // 下载文件的名字
          document.body.appendChild(a);
          a.click();
        });
      }
    },
    // 设置最大作品数
    submitMax: function submitMax() {
      var _this4 = this;
      this.maxDialog = true;
      (0, _project.setMaxWorks)({
        idList: this.checkBoxs,
        value: this.maxForm.max
      }).then(function () {
        _this4.getUnitList();
        _this4.maxDialog = false, _this4.$message.success("操作成功。");
      });
    },
    // 设置最大审核数
    submitAuditMax: function submitAuditMax() {
      var _this5 = this;
      this.maxAuditDialog = true;
      (0, _project.submitAuditMax)({
        idList: this.checkBoxs,
        value: this.maxAuditForm.max
      }).then(function () {
        _this5.getUnitList();
        _this5.maxAuditDialog = false, _this5.$message.success("操作成功。");
      });
    },
    // 获取项目单位列表
    getUnitList: function getUnitList() {
      var _this6 = this;
      (0, _project.unitList)({
        matchId: this.$route.query.matchId,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        queryValue: this.queryValue
      }).then(function (res) {
        var data = res.data;
        _this6.listData = data.list;
        _this6.totalData = data.total;
      });
    },
    // 移出项目单位
    removeUnit: function removeUnit(row) {
      var _this7 = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _project.unitRemove)({
          idList: id
        }).then(function () {
          _this7.getUnitList();
          _this7.$message.success("操作成功。");
        });
      }).catch(function () {
        _this7.$message.info("取消删除。");
      });
    },
    // 提交新增项目单位
    submit: function submit() {
      var _this8 = this;
      var nodeTree = this.$refs.tree.getCheckedNodes();
      this.nodeList = [];
      nodeTree.forEach(function (item) {
        if (item.type === 4) {
          _this8.nodeList.push(item.id);
        }
      });
      (0, _project.unitAdd)({
        matchId: this.$route.query.matchId,
        idList: this.nodeList
      }).then(function (res) {
        if (res.code === 2000) {
          _this8.$message.success("操作成功。");
          _this8.addDialog = false;
          _this8.getUnitList();
        }
      });
    },
    // 获取项目单位树列表
    getUnitTreeList: function getUnitTreeList() {
      var _this9 = this;
      (0, _project.unitTree)({
        matchId: this.$route.query.matchId
      }).then(function (res) {
        _this9.treeList = res.data;
      });
    },
    // 模糊查询
    search: function search(e) {
      this.queryValue = e.queryValue;
      this.getUnitList();
    },
    dels: function dels() {},
    // 新增
    save: function save() {
      this.addDialog = true;
      // this.$router.push("/object/objectUnitSetAdd");
      this.getUnitTreeList();
    },
    edit: function edit() {},
    handleSelectionChange: function handleSelectionChange(e) {
      var _this0 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this0.checkBoxs.push(item.id);
      });
    },
    handleSelectionChange2: function handleSelectionChange2() {},
    deleteById: function deleteById() {},
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getUnitList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getUnitList();
    },
    handleClose: function handleClose(done) {
      done();
    },
    handleClose2: function handleClose2(done) {
      done();
    }
  },
  created: function created() {
    this.matchId = this.$route.query.matchId;
    // 获取项目单位列表
    this.getUnitList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};